import { ReactNode } from 'react'

export enum CellType {
  NUMBER = 'number',
  TEXT = 'text',
}
export enum ColumnFixedVariants {
  LEFT = 'fixed_left',
  RIGHT = 'fixed_right',
}

export enum ColumnAlignVariants {
  LEFT = 'left',
  CENTER = 'center',
  RIGHT = 'right',
}

export type ColumnWidthType = string | number | undefined

export type DefaultDataType<D> = D & {
  id: string | number
}

export type ColumnType<D> = {
  key: D extends {} ? keyof DefaultDataType<D> | string : string
  title?: ReactNode
  variant?: CellType
  sortable?: boolean
  fixed?: ColumnFixedVariants
  align?: ColumnAlignVariants
  width?: ColumnWidthType
  maxWidth?: ColumnWidthType
  minWidth?: ColumnWidthType
  render?: (value: DefaultDataType<D>[keyof DefaultDataType<D>], record: DefaultDataType<D>) => ReactNode
}
